// ============================================================================
// FEATURE FLAGS CONFIGURATION
// ============================================================================
// This file contains feature flags that can be easily toggled for development
// and testing purposes. Update these flags as needed.

export const FEATURE_FLAGS = {
  // ⚠️  AUTHENTICATION FEATURE FLAG - CHANGE THIS TO ENABLE/DISABLE AUTH
  // Set to 'true' to require Microsoft authentication before accessing chat
  // Set to 'false' to skip authentication and go directly to chat (for development)
  REQUIRE_AUTHENTICATION: true,
  
  ENABLE_MOCK_API: process.env.REACT_APP_USE_MOCK_API === 'true',
  
  // Logging Configuration
  ENABLE_DEBUG_LOGGING: process.env.NODE_ENV === 'development',
  ENABLE_PRODUCTION_CONSOLE_LOGS: process.env.REACT_APP_ENABLE_PROD_CONSOLE === 'true',
  ENABLE_GRAFANA_LOGGING: true, // Always enabled for production log collection
  ENABLE_CONVERSATION_LOGGING: true, // Log user conversations for analysis
  ENABLE_PERFORMANCE_LOGGING: true, // Track performance metrics
  
  // Conversation Content Logging - Privacy Settings
  LOG_MESSAGE_CONTENT_IN_DEV: true, // Full message content in development
  LOG_MESSAGE_CONTENT_IN_PROD: false, // Only metadata in production for privacy
  LOG_MESSAGE_LENGTH_ALWAYS: true, // Always log message length for analytics
} as const;

// ============================================================================
// CONFIGURATION NOTES:
// ============================================================================
// 
// REQUIRE_AUTHENTICATION:
// - true:  Users must authenticate with Microsoft before accessing chat
// - false: Skip authentication, go directly to chat (useful for development)
//
// Logging Flags:
// - ENABLE_DEBUG_LOGGING: Full console logging in development only
// - ENABLE_PRODUCTION_CONSOLE_LOGS: Allow some console logs in production
// - ENABLE_GRAFANA_LOGGING: Structure logs for Grafana/Loki ingestion
// - ENABLE_CONVERSATION_LOGGING: Track user conversations for analysis
// - LOG_MESSAGE_CONTENT_IN_PROD: Set to false to respect user privacy
//
// To quickly toggle authentication:
// 1. Open this file (src/config/featureFlags.ts)
// 2. Change REQUIRE_AUTHENTICATION to true or false
// 3. Save the file - the app will automatically reload
//
// ============================================================================
